export default __webpack_public_path__ + "static/media/folajuNcake_w320.bd090980.jpeg";